import React, { Component } from 'react'
import moment from 'moment'
import { get, isEmpty, set } from 'lodash'
import ContractsApi from '../../../../../api/Sales/SalesContracts'
import { arrVal, sessionItemByKeys, strVal } from '../../../../../modules/Utils'
import { compose } from 'recompose'
import withUrlFetch from '../../../../../elements/Select/withUrlFetch'
import withSpinning from '../../../../../elements/HOC/withSpinning'
import withSort from '../../../../../elements/HOC/withSort'
import CustomSelect from '../../../../../elements/Select/CustomSelect'
import { Button, Form, message, Popconfirm, Select } from 'antd'
import Dropdowns from '../../../../../api/Dropdowns'
import TextColumn from '../../../../../elements/Table/Columns/Text'
import DropdownColumn from '../../../../../elements/Table/Columns/Dropdown'
import NumberColumn from '../../../../../elements/Table/Columns/Number'
import TaxType from '../../../../../elements/Select/Lines/TaxType'
import CustomTable from '../../../../../elements/Table/CustomTable'

class Rates extends Component {
  uuid = moment().unix()

  constructor(props) {
    super(props)
    let data = []
    if (!isEmpty(get(props, 'contract.rates'))) data = props.contract.rates.map((item) => ({ ...item }))
    data.forEach((i) => {
      if (!i.key) i.key = (this.uuid++).toString()
    })
    this.cacheData = data.map((item) => ({ ...item }))
    this.state = {
      data,
      fetching: false,
      requisitionList: [],
    }
    this.api = new ContractsApi()
    this.key = props.supplier._key
    this.type = props.type
    if (!isEmpty(strVal(props.contract.company, '_id'))) {
      const owner = strVal(props.contract.company, '_id')
      const url = `products/` + `?owner=${owner}&state=Active` + '&select=*'
      this.url = url
      this.ProductsSelect = compose(
        withUrlFetch({
          name: 'products',
          url: url,
          cache: true,
          forceFetch: true,
        }),
        withSpinning,
        withSort
      )(CustomSelect)
    } else {
      this.ProductsSelect = Select
    }
  }

  dropdownApi = new Dropdowns()
  columns = [
    {
      Header: 'Item',
      accessor: 'no',
      Cell: ({ value, original }) => (
        <TextColumn onChange={this.handleChange} value={value} record={original} column={'no'} />
      ),
    },
    {
      Header: 'Product',
      accessor: 'product._id',
      // Cell: ({value, original}) => (
      //   <DropdownColumn
      //     SelectCmp={this.ProductsSelect}
      //     display={
      //       get(original, 'product.name') ||
      //       sessionItemByKeys(
      //         `products_${this.url}_dropdown`,
      //         value,
      //         '_id',
      //         'name',
      //       )
      //     }
      //     value={value}
      //     record={original}
      //     keyAtr={'_id'}
      //     valueAtr={'name'}
      //     column={'product._id'}
      //     onChange={this.handleChange}
      //   />
      // ),
      Cell: ({ value, original }) => (
        <TextColumn onChange={this.handleChange} value={value} record={original} column={'product._id'} />
      ),
    },
    {
      Header: 'Description',
      accessor: 'description',
      Cell: ({ value, original }) => (
        <TextColumn onChange={this.handleChange} value={value} record={original} column={'description'} />
      ),
    },
    {
      Header: 'UoM',
      accessor: 'uom',
      // Cell: ({value, original}) => {
      //   const data = arrVal(
      //     {
      //       data: sessionItemByKeys(
      //         `products_${this.url}_dropdown`,
      //         get(original, 'product._id'),
      //         '_id',
      //         'price',
      //       ),
      //     },
      //     'data',
      //   )
      //   return (
      //     <DropdownColumn
      //       SelectCmp={compose(
      //         withData({
      //           data,
      //         }),
      //         withSort,
      //       )(CustomSelect)}
      //       value={value}
      //       record={original}
      //       column={'uom'}
      //       keyAtr={'uom.key'}
      //       valueAtr={'uom.name'}
      //       display={get(original, 'name') || value}
      //       onChange={this.handleChange}
      //     />
      //   )
      // },
      Cell: ({ value, original }) => (
        <TextColumn onChange={this.handleChange} value={value} record={original} column={'uom'} />
      ),
    },
    {
      Header: 'Unit Price',
      accessor: 'rate',
      Cell: ({ value, original }) => (
        <NumberColumn onChange={this.handleChange} value={value} record={original} column={'rate'} />
      ),
    },
    {
      Header: 'Tax Type',
      accessor: 'tax.type',
      Cell: ({ value, original }) => (
        <DropdownColumn
          SelectCmp={TaxType}
          value={value}
          record={original}
          keyAtr={'key'}
          valueAtr={'value'}
          column={'tax.type'}
          onChange={this.handleChange}
        />
      ),
    },
    {
      Header: 'Tax Rate',
      accessor: 'tax.rate',
      Cell: ({ value, original }) => (
        <NumberColumn onChange={this.handleChange} value={value} record={original} column={'tax.rate'} />
      ),
    },
    {
      Header: 'Operation',
      accessor: 'operation',
      Cell: ({ value, original }) => {
        const { editable } = original
        return (
          <div className="editable-row-operations">
            {editable ? (
              <span>
                <a onClick={() => this.save(original.key)}>Save</a>
                <span className="ant-divider" />
                <Popconfirm title="Sure to cancel?" onConfirm={() => this.cancel(original.key)}>
                  <a>Cancel</a>
                </Popconfirm>
              </span>
            ) : (
              [
                <a onClick={() => this.edit(original.key)}>Edit</a>,
                <span className="ant-divider" />,
                <Popconfirm title="Sure to remove?" onConfirm={() => this.remove(original.key)}>
                  <a>Remove</a>
                </Popconfirm>,
              ]
            )}
          </div>
        )
      },
    },
  ]
  add = () => {
    const newData = [...this.state.data]
    newData.push({ key: (this.uuid++).toString(), editable: true })
    this.setState({ data: newData })
  }

  cancel = (key) => {
    const newData = [...this.state.data]
    const target = newData.find((item) => key === item.key)
    if (target) {
      Object.assign(
        target,
        this.cacheData.find((item) => key === item.key)
      )
      delete target.editable
      if (Object.keys(target).length === 1 && Object.keys(target)[0] === 'key') this.remove(target.key)
      else this.setState({ data: newData })
      this.props.updateContract('rates', newData)
    }
  }

  remove = (key) => {
    let newData = [...this.state.data]
    newData = newData.filter((item) => key !== item.key)
    this.setState({ data: newData })
    this.props.updateContract('rates', newData)
  }

  edit = (key) => {
    const newData = [...this.state.data]
    const target = newData.find((item) => key === item.key)
    if (target) {
      target.editable = true
      this.setState({ data: newData })
      this.props.updateContract('rates', newData)
    }
  }

  save = (key) => {
    this.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        const newData = [...this.state.data]
        const target = newData.filter((item) => key === item.key)[0]
        if (target) {
          delete target.editable
          this.setState({ data: newData })
          this.cacheData = newData.map((item) => ({ ...item }))
          this.props.updateContract('rates', newData)
        }
      } else {
        message.error('Invalid data')
      }
    })
  }

  handleChange = (value, key, column) => {
    const newData = [...this.state.data]
    const target = newData.find((item) => key === item.key)
    if (target) {
      if (column === 'product._id') {
        set(target, 'uom', undefined)
        set(target, 'tax.rate', undefined)
        set(target, 'rate', undefined)
        set(target, 'tax.type', undefined)
        set(target, 'name', undefined)
      }
      if (column === 'uom') {
        const data = arrVal(
          {
            data: sessionItemByKeys(`products_${this.url}_dropdown`, get(target, 'product._id'), '_id', 'price'),
          },
          'data'
        )
        const uom = data.find((u) => u.uom.key === value)
        set(target, 'tax.rate', get(uom, 'tax.value'))
        set(target, 'rate', get(uom, 'price'))
        set(target, 'tax.type', get(uom, 'tax.type'))
        set(target, 'name', get(uom, 'uom.name'))
      }
      set(target, column, value)
      this.setState({ data: newData })
    }
  }

  render() {
    const { type } = this.props
    if (type === 'view') this.columns = this.columns.filter((c) => c.accessor !== 'operation')
    return (
      <CustomTable
        CreateButton={() => (
          <Button
            style={{ float: 'left', marginRight: 10 }}
            size={'small'}
            onClick={this.add}
            type={'primary'}
            icon={'plus'}>
            Add a Rate
          </Button>
        )}
        hide={{ refresh: true, create: type === 'view' }}
        showPagination={false}
        data={this.state.data}
        loading={this.state.fetching}
        pagination={false}
        columns={this.columns}
        size="small"
        defaultSorted={[
          {
            id: 'no',
            desc: false,
          },
        ]}
        style={{ marginTop: 10 }}
      />
    )
  }
}

export default Form.create()(Rates)
